import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

/**
 * Neutral, page-agnostic loading placeholder used as the route-level Suspense
 * fallback while a lazily-loaded page chunk downloads. It deliberately mirrors
 * the common "page header + toolbar + rows" shape so the hand-off to a page's
 * own data-loading skeleton reads as one continuous shimmer rather than a
 * spinner flash.
 */
export function PageSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'mr-auto w-full max-w-screen-2xl px-5 pt-3 sm:px-4',
        className
      )}
      aria-hidden="true"
    >
      {/* Header */}
      <div className="flex flex-col gap-2 sm:gap-1">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-72 max-w-full" />
      </div>

      {/* Toolbar */}
      <div className="mt-6 flex items-center justify-between gap-3">
        <Skeleton className="h-9 w-full max-w-md" />
        <Skeleton className="h-9 w-28 shrink-0" />
      </div>

      {/* Rows */}
      <div className="mt-4 flex flex-col gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </div>
  );
}
